import { z } from 'zod';

export const passwordSchema = z
  .object({
    password: z.string().min(1),
    confirm_password: z.string().min(1),
  })
  .refine((d) => d.password === d.confirm_password, {
    path: ['confirm_password'],
    message: 'passwords_must_match',
  });

export type PasswordInput = z.infer<typeof passwordSchema>;
